// List of common country codes for phone numbers (Available on App Release)
export const COUNTRY_CODES = [
  { value: '+91', label: 'India (+91)', country: 'IN', flag: '🇮🇳' },
  { value: '+54', label: 'Argentina (+54)', country: 'AR', flag: '🇦🇷' },
  { value: '+55', label: 'Brazil (+55)', country: 'BR', flag: '🇧🇷' },
  { value: '+20', label: 'Egypt (+20)', country: 'EG', flag: '🇪🇬' },
  { value: '+679', label: 'Fiji (+679)', country: 'FJ', flag: '🇫🇯' },
  { value: '+33', label: 'France (+33)', country: 'FR', flag: '🇫🇷' },
  { value: '+39', label: 'Italy (+39)', country: 'IT', flag: '🇮🇹' },
  { value: '+81', label: 'Japan (+81)', country: 'JP', flag: '🇯🇵' },
  { value: '+82', label: 'Korea, Republic of (+82)', country: 'KR', flag: '🇰🇷' },
  { value: '+960', label: 'Maldives (+960)', country: 'MV', flag: '🇲🇻' },
  { value: '+52', label: 'Mexico (+52)', country: 'MX', flag: '🇲🇽' },
  { value: '+977', label: 'Nepal (+977)', country: 'NP', flag: '🇳🇵' },
  { value: '+64', label: 'New Zealand (+64)', country: 'NZ', flag: '🇳🇿' },
  { value: '+234', label: 'Nigeria (+234)', country: 'NG', flag: '🇳🇬' },
  { value: '+51', label: 'Peru (+51)', country: 'PE', flag: '🇵🇪' },
  { value: '+27', label: 'South Africa (+27)', country: 'ZA', flag: '🇿🇦' },
  { value: '+34', label: 'Spain (+34)', country: 'ES', flag: '🇪🇸' },
  { value: '+41', label: 'Switzerland (+41)', country: 'CH', flag: '🇨🇭' },
  { value: '+886', label: 'Taiwan (+886)', country: 'TW', flag: '🇹🇼' },
  { value: '+44', label: 'United Kingdom (+44)', country: 'GB', flag: '🇬🇧' },
  { value: '+1', label: 'United States (+1)', country: 'US', flag: '🇺🇸' }
];

// Default country code (India)
export const DEFAULT_COUNTRY_CODE = '+91';
